import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1332e12c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "user-photo"
};
const _hoisted_2 = ["src"];

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Войти ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");

  const _component_login_icon = _resolveComponent("login-icon");

  return _ctx.$route.name !== 'sign-in' ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [!_ctx.can('isGuest') ? (_openBlock(), _createBlock(_component_router_link, {
    key: 0,
    to: {
      name: 'profile/info'
    },
    class: "user"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
      class: "image",
      src: _ctx.user('photo'),
      alt: ""
    }, null, 8, _hoisted_2)]), _createElementVNode("span", null, _toDisplayString(_ctx.user('name')), 1)]),
    _: 1
  })) : (_openBlock(), _createBlock(_component_router_link, {
    key: 1,
    to: {
      name: 'sign-in'
    },
    class: "button login-button"
  }, {
    default: _withCtx(() => [_hoisted_3, _createVNode(_component_login_icon, {
      style: {
        "margin-left": "5px"
      }
    })]),
    _: 1
  }))], 64)) : _createCommentVNode("", true);
}